"use strict";var t=require("@apollo/client"),o=require("./CategoryModel-cjs-CxTItWYs.js"),e=t.gql`
  query GetFiltersList($search: SearchInput!, $storeId: ID!) {
    getFiltersList(search: $search, storeId: $storeId) {
      filtersList {
        brand
        categoryid
        categoryname
      }
    }
  }
`,n=t.gql`
  fragment BaseProductV2 on Product {
    id
    description
    name
    brand
    photosUrls
    sku
    unit
    price
    specialPrice
    promotion {
      description
      type
      isActive
      conditions
    }
    variants {
      selectors
      productModifications
    }
    isAvailable
    stock
    nutritionalDetails
    clickMultiplier
    subQty
    subUnit
    maxQty
    minQty
    specialMaxQty
    ean
    boost
    showSubUnit
    isActive
    slug
    categoriesPath
    categories {
      id
      name
    }
    formats {
      format
      equivalence
      unitEquivalence
      minQty
      maxQty
    }
    tags {
      id
      tagReference
      name
      filter
      enabled
      description
      backgroundColor
      textColor
    }
  }
`,r=t.gql`
  ${n}
  query GetProducts(
    $pagination: paginationInput
    $search: SearchInput
    $storeId: ID!
    $categoryId: ID
    $onlyThisCategory: Boolean
    $filter: ProductsFilterInput
    $orderBy: productsSortInput
    $variants: Boolean
    $showProductsWithoutStock: Boolean
  ) {
    getProducts(
      pagination: $pagination
      search: $search
      storeId: $storeId
      categoryId: $categoryId
      onlyThisCategory: $onlyThisCategory
      filter: $filter
      orderBy: $orderBy
      variants: $variants
      showProductsWithoutStock: $showProductsWithoutStock
    ) {
      redirectTo
      products {
        ...BaseProductV2
      }
      paginator {
        pages
        page
      }
    }
  }
`,a=t.gql`
  query GetProductsByCategory(
    $categoryId: ID!
    $pagination: paginationInput
    $onlyThisCategory: Boolean
  ) {
    getProductsByCategory(
      categoryId: $categoryId
      pagination: $pagination
      onlyThisCategory: $onlyThisCategory
    ) {
      products {
        id
        name
        brand
        photosUrls
        sku
        unit
        price
        specialPrice
        stock
        nutritionalDetails
        clickMultiplier
        category {
          name
          id
        }
        subQty
        subUnit
        maxQty
        specialMaxQty
        ean
        boost
        showSubUnit
      }
      paginator {
        pages
        page
      }
    }
  }
`,i=t.gql`
  query GetProductsByFilter(
    $pagination: paginationInput
    $filter: productsFilterInput
    $storeId: ID!
    $search: SearchInput
    $variants: Boolean
  ) {
    getProducts(
      pagination: $pagination
      filter: $filter
      storeId: $storeId
      search: $search
      variants: $variants
    ) {
      products {
        id
        name
        brand
        photosUrls
        sku
        unit
        price
        specialPrice
        stock
        nutritionalDetails
        clickMultiplier
        category {
          name
          id
        }
        variants {
          selectors
          productModifications
        }
        subQty
        subUnit
        maxQty
        specialMaxQty
        ean
        boost
        showSubUnit
      }
      paginator {
        pages
        page
      }
    }
  }
`,s=t.gql`
  query GetShowcaseProducts(
    $categoryId: ID!
    $pagination: paginationInput
    $onlyThisCategory: Boolean
  ) {
    getProductsByCategory(
      categoryId: $categoryId
      pagination: $pagination
      onlyThisCategory: $onlyThisCategory
    ) {
      products {
        id
        name
        brand
        photosUrls
        sku
        unit
        price
        specialPrice
        stock
        nutritionalDetails
        clickMultiplier
        category {
          name
          id
        }
        subQty
        subUnit
        maxQty
        specialMaxQty
        ean
        boost
        showSubUnit
      }
      paginator {
        pages
        page
      }
    }
  }
`,u=t.gql`
  ${n}
  query GetSuggestedProductsBySKU(
    $sku: String!
    $pagination: paginationInput
    $storeId: ID!
    $orderBy: productsSortInput
    $variants: Boolean
    $showProductsWithoutStock: Boolean
  ) {
    getSuggestedProductsBySKU(
      sku: $sku
      pagination: $pagination
      storeId: $storeId
      orderBy: $orderBy
      variants: $variants
      showProductsWithoutStock: $showProductsWithoutStock
    ) {
      redirectTo
      products {
        ...BaseProductV2
      }
      paginator {
        pages
        page
      }
    }
  }
`,c=t.gql`
  ${o.C}
  query GetProductRecommendations(
    $getProductRecommendationsInput: GetProductRecommendationsInput!
  ) {
    getProductRecommendations(
      getProductRecommendationsInput: $getProductRecommendationsInput
    ) {
      ...CatalogProductModel
    }
  }
`,l=t.gql`
  ${o.C}
  query GetProductsBySKU($getProductsBySkuInput: GetProductsBySKUInput!) {
    getProductsBySKU(getProductsBySKUInput: $getProductsBySkuInput) {
      ...CatalogProductModel
    }
  }
`,d=t.gql`
  ${o.C}
  query GetProductsBySKU($getProductsBySkuInput: GetProductsBySKUInput!) {
    getProductsBySKU(getProductsBySKUInput: $getProductsBySkuInput) {
      ...CatalogProductModel
    }
  }
`,g=t.gql`
  ${o.C}
  query GetSuggestedProducts(
    $getSuggestedProductsInput: GetSuggestedProductsInput!
  ) {
    getSuggestedProducts(
      getSuggestedProductsInput: $getSuggestedProductsInput
    ) {
      ...CatalogProductModel
    }
  }
`,p=t.gql`
  fragment Ingredients on Ingredients {
    ingredientsNames
  }
`,y=t.gql`
  fragment NutritionalComponent on NutritionalComponent {
    value
    valuePerPortion
    unitName
  }
`,$=t.gql`
  ${y}
  fragment NutritionalDetails on NutritionalDetails {
    basicUnitName
    portionText
    portionValue
    portionUnitName
    numPortions
    energy {
      ...NutritionalComponent
    }
    protein {
      ...NutritionalComponent
    }
    fatTotal {
      ...NutritionalComponent
    }
    fatSat {
      ...NutritionalComponent
    }
    fatMono {
      ...NutritionalComponent
    }
    fatPoli {
      ...NutritionalComponent
    }
    fatTrans {
      ...NutritionalComponent
    }
    fatCholesterol {
      ...NutritionalComponent
    }
    carb {
      ...NutritionalComponent
    }
    sugars {
      ...NutritionalComponent
    }
    fiber {
      ...NutritionalComponent
    }
    sodium {
      ...NutritionalComponent
    }
  }
`,I=t.gql`
  fragment TechnicalDetails on TechnicalDetails {
    brandName
    packagingTypeName
    content
    drainedContent
    flavor
    originCountryName
  }
`,P=t.gql`
  ${p}
  ${$}
  ${I}
  fragment ProductExternalInfo on ProductExternalInfo {
    description
    seals
    warnings
    ingredients {
      ...Ingredients
    }
    nutritionalDetails {
      ...NutritionalDetails
    }
    technicalDetails {
      ...TechnicalDetails
    }
  }
`,m=t.gql`
  ${P}
  query GetProductExternalInfo($clientId: ID!, $storeId: ID!, $sku: String!) {
    getProductExternalInfo(clientId: $clientId, storeId: $storeId, sku: $sku) {
      ...ProductExternalInfo
    }
  }
`,h=t.gql`
  ${$}
  ${I}
  fragment ProductExternalInfov3 on ProductExternalInfo {
    description
    seals
    warnings
    ingredients
    nutritionalDetails {
      ...NutritionalDetails
    }
    technicalDetails {
      ...TechnicalDetails
    }
  }
`,f=t.gql`
  ${h}
  query GetProductExternalInfov3(
    $getProductExternalInfoInput: GetProductExternalInfoInput!
  ) {
    getProductExternalInfo(
      getProductExternalInfoInput: $getProductExternalInfoInput
    ) {
      ...ProductExternalInfov3
    }
  }
`;exports.a=m,exports.b=f,exports.c=c,exports.d=r,exports.e=a,exports.f=i,exports.g=e,exports.h=l,exports.i=d,exports.j=s,exports.k=g,exports.l=u;